export default __webpack_public_path__ + "static/PNS_PHOTOGRAPHY_1-0593ffe8873e5db896c673d367ea37f5.jpg";